module.exports = __webpack_public_path__ + "img/yzkc-logo.88c02e9a.png";